/*
* Create a new guid
* @returns {String} - returns a guid
*/
export function generateGuid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}



// WEBPACK FOOTER //
// ./d:/dbs/el/aapusc/private/client/packages/primitive-utilities/src/guid.es